export default __webpack_public_path__ + "static/media/version-history.fca2305d.svg";